import { render } from "./HowToPage.vue?vue&type=template&id=391cc494"
import script from "./HowToPage.vue?vue&type=script&lang=js"
export * from "./HowToPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__